export default __webpack_public_path__ + "static/dana-3747c02fc5dafab5b921d5e9b870fe9d.svg";